<template>
  <div class="product">
    <HeaderNav :lmid="18"/>
    <Banner :msg="18" />

    <section class="product_list">
      <div class="w1520 p95 p95_">
        <div class="box">
          <div
            class="item wow animate__animated animate__fadeInUp"
            v-for="(item, index) in list"
            :key="index"
          >
            <router-link :to="{ path: '/productInfo?id=' + item.id }">
              <figure>
                <img :src="item.litpic" alt="" image />
              </figure>
              <figcaption>
                <div class="title ellipsis">{{ item.typename }}</div>
                <div class="desc ellipsis">
                  {{ item.pro_desc }}
                </div>
              </figcaption>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
    };
  },
  beforeMount() {
    let that = this;
    this.$httpGet("/products", {})
      .then((res) => {
        that.list = res;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>
